import React from 'react'
import { TextSm } from '../../../components/text'
import chevron from "../../../assets/icons/chevron.svg";

export const SeeMore = ({ className="", text="See More", style={}, ...rest }) => {
  return (
    <div 
      className={`flex gap-3 items-center mx-auto ${className}`}
      style={style}
      { ...rest }
    >
      <TextSm className="text-gray-500 whitespace-nowrap">{text}</TextSm>
      <img
        src={chevron}
        className="
          h-6 w-6 xl:h-8 xl:w-8 rotate-180
          dark-svg
        "
      />
    </div>
  )
}
